import { render, staticRenderFns } from "./PersonalCenterShareTab.vue?vue&type=template&id=89952d2e&"
import script from "./PersonalCenterShareTab.vue?vue&type=script&lang=js&"
export * from "./PersonalCenterShareTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports